export const VALID_HELM_URL_PROTOCOLS = ['http', 'https', 's3', 'oci'];
export const VALID_GIT_URL_PROTOCOLS = ['http', 'https', 'ssh'];
export const VALID_HTTP_URL_PROTOCOLS = ['http', 'https'];
